<template>
  <div>
    <vx-card no-shadow>

        <vs-button @click="ViewAuthSettings()" class="ml-4 mt-2" type="border" color="primary">Go to Authentication Settings</vs-button>
    </vx-card>
    <vx-card no-shadow class="mt-4">
      <label>DevOps Personal Access Token</label>
      <vs-input v-model="pat" type="password"></vs-input>
      <vs-button class="mt-2" @click="SavePAT()" :disabled="savingPAT">Save</vs-button>
    </vx-card>
  </div>
</template>

<script>
import Vue from 'vue'

export default {
  data () {
    return {
      old_password: '',
      new_password: '',
      confirm_new_password: '',
      pat: '',
      savingPAT: false,
    }
  },
  methods:{
    ViewAuthSettings () {
      window.location.href = window.location.origin + '/settings'
    },
    async SavePAT() {
      this.savingPAT = true
      try {
        console.log('save pat')
        await this.$store.dispatch('ActionSaveDevOpsPAT', this.pat)
      } catch (e) {
        console.error(e)
      }
      this.savingPAT = false
    }
  },
  mounted() {
    this.pat = this.$store.getters.GetDevOpsPAT
  }
}
</script>
